<template>
  <DashboardPanel
    class="performance-panel"
    title="Today vs This Month"
    subtitle="Business, profit, expense and credits at a glance."
    icon="activity"
  >
    <div class="performance-cards">
      <div v-for="row in rows" :key="row.label" class="performance-card" :class="row.tone">
        <div class="performance-card-head">
          <span class="performance-chip" :class="row.tone"><vue-feather :type="row.icon"></vue-feather></span>
          <span>{{ row.label }}</span>
        </div>
        <div class="performance-values">
          <div>
            <small>Today</small>
            <strong :class="row.todayTone">{{ row.today }}</strong>
          </div>
          <div>
            <small>This Month</small>
            <strong :class="row.monthTone">{{ row.month }}</strong>
          </div>
        </div>
        <small v-if="row.monthNote" class="performance-note">{{ row.monthNote }}</small>
      </div>
    </div>
  </DashboardPanel>
</template>

<script>
import DashboardPanel from "./DashboardPanel.vue";
import { buildPerformanceRows } from "../dashboardCards";

export default {
  name: "PerformancePanel",
  components: { DashboardPanel },
  props: {
    summary: { type: Object, required: true },
  },
  computed: {
    rows() {
      return buildPerformanceRows(this.summary);
    },
  },
};
</script>
